import React from 'react'
import './loader-overlay-component.scss'
import { LoaderOverlayProps } from '../../types'

const LoaderOverlay = ({
  isVisible,
  message = 'Processing...',
  className = '',
}: LoaderOverlayProps) => {
  if (!isVisible) return null

  return (
    <div className={`loader-overlay ${className}`.trim()} data-testid='loader-overlay'>
      <div className='loader-overlay-content'>
        <div className='loader-spinner' data-testid='loader-spinner'></div>
        <p className='loader-message'>{message}</p>
      </div>
    </div>
  )
}

export { LoaderOverlay }
